/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_polygon_set_destination_dialog_description = /** @type {(inputs: {}) => string} */ () => {
	return `Selecciona la tarjeta a la que se enviarán los fondos de esta cuenta Polygon`
};

const en_accounts_polygon_set_destination_dialog_description = /** @type {(inputs: {}) => string} */ () => {
	return `Select the card where funds from this Polygon account will be sent`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_polygon_set_destination_dialog_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_polygon_set_destination_dialog_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_polygon_set_destination_dialog_description", locale)
	if (locale === "es") return es_accounts_polygon_set_destination_dialog_description(inputs)
	return en_accounts_polygon_set_destination_dialog_description(inputs)
};
export { accounts_polygon_set_destination_dialog_description as "accounts.polygon.set_destination_dialog_description" }